import { defineComponent as _defineComponent } from 'vue'

import { onBeforeMount } from "@vue/runtime-core";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const router = useRouter()

onBeforeMount(() => {
  router.replace({
    name: 'ManualCategories'
  })
})

return (_ctx: any,_cache: any) => {
  return " HomeView "
}
}

})